module.exports = __webpack_public_path__ + "img/Ellipse-299.72d9d3f4.svg";